import {
    RESET_GROUP_PAGE,
    GROUP_PAGE_OPEN_REPORT_GROUP_PHOTO_DIALOG,
    GROUP_PAGE_CLOSE_REPORT_GROUP_PHOTO_DIALOG,
    GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO,
    GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO_DONE
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    open: false,
    submitting: false,
    error: false,
    reviewStatus: null,
    activityId: null,
    newsPostUuid: null,
    imageUuid: null
};

/** selector */
export const selectGroupPageReportPhotoDialog = (state) => state.groupPageReportPhotoDialog;

export const selectDialogOpen = (state) => {
    const reportPhotoDialog = selectGroupPageReportPhotoDialog(state);
    return reportPhotoDialog.open;
};

export const selectSubmitting = (state) => {
    const reportPhotoDialog = selectGroupPageReportPhotoDialog(state);
    return reportPhotoDialog.submitting;
};

export const selectReviewStatus = (state) => {
    const reportPhotoDialog = selectGroupPageReportPhotoDialog(state);
    return reportPhotoDialog.reviewStatus;
};

export const selectActivityId = (state) => {
    const reportPhotoDialog = selectGroupPageReportPhotoDialog(state);
    return reportPhotoDialog.activityId;
};

export const selectNewsPostUuid = (state) => {
    const reportPhotoDialog = selectGroupPageReportPhotoDialog(state);
    return reportPhotoDialog.newsPostUuid;
};

export const selectImageUuid = (state) => {
    const reportPhotoDialog = selectGroupPageReportPhotoDialog(state);
    return reportPhotoDialog.imageUuid;
};

/** action handlers */
const openReportGroupPhotoDialog = (state, action) => {
    return {
        ...state,
        open: true,
        activityId: action.activityId || null,
        newsPostUuid: action.newsPostUuid || null,
        imageUuid: action.imageUuid || null
    };
};

const closeReportGroupPhotoDialog = (state) => INITIAL_STATE;

const submitReportGroupPhoto = (state) => {
    return {
        ...state,
        submitting: true
    };
};

const submitReportGroupPhotoDone = (state, action) => {
    if (action.error) {
        return {
            ...state,
            error: true,
            submitting: false
        };
    }
    return {
        ...state,
        error: false,
        submitting: false,
        reviewStatus: action.reviewStatus
    };
};

const resetGroupPage = () => {
    return INITIAL_STATE;
};

const handlers = {
    [GROUP_PAGE_OPEN_REPORT_GROUP_PHOTO_DIALOG]: openReportGroupPhotoDialog,
    [GROUP_PAGE_CLOSE_REPORT_GROUP_PHOTO_DIALOG]: closeReportGroupPhotoDialog,
    [GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO]: submitReportGroupPhoto,
    [GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO_DONE]: submitReportGroupPhotoDone,
    [RESET_GROUP_PAGE]: resetGroupPage
};

export default function groupPageReportPhotoDialogReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
